import { render, staticRenderFns } from "./customerLedger.vue?vue&type=template&id=35617030&scoped=true"
import script from "./customerLedger.vue?vue&type=script&lang=js"
export * from "./customerLedger.vue?vue&type=script&lang=js"
import style0 from "./customerLedger.vue?vue&type=style&index=0&id=35617030&prod&scoped=true&lang=css"
import style1 from "./customerLedger.vue?vue&type=style&index=1&id=35617030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35617030",
  null
  
)

export default component.exports